export default "__VITE_ASSET__N9owHRPi__"